var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-dependency"},[(_vm.context)?[_vm._v(" "+_vm._s(_vm.context)+" ")]:[_vm._v("---")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }